import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{attrs:{"fluid":""}},[_c(VRow,[_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c('manage-tree',{attrs:{"tree-data":_vm.treeDataUserInterests,"type":_vm.AUDIENCE_TYPES.INTEREST}})],1),_c(VCol,{attrs:{"cols":"12","md":"6"}},[_c('manage-tree',{attrs:{"tree-data":_vm.treeDataUserVisitorProperties,"type":_vm.AUDIENCE_TYPES.PROPERTY}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }